//管理整个项目中所有的数据请求

//引入二次封装后的axios
import requests from "./ajax";

//引入mockjs模拟的axios
import mockRequests from './mockAjax'

//通过mock js 获取首页轮播图的数据
export const reqGetBannerList = () => mockRequests.get('/bannerList')
//通过mock js 获取首页产品展示的数据
export const reqGetProductShow = () => mockRequests.get('/productShow')

//通过mock js 获取新闻页的数据
export const reqGetNewsList = () => mockRequests.get('/newList')
//通过mock js 获取行业动态的数据
export const reqGetTrends = () => mockRequests.get('/trends')
//通过mock js 获取新闻推荐的数据
export const reqGetRecommendedNews = () => mockRequests.get('/recommendedNews')

//通过mock js 获取知识页的数据
export const reqGetKnowledgeList = () => mockRequests.get('/knowledgeList')
//通过mock js 获取知识的数据
export const reqKnowledge = () => mockRequests.get('/knowledge')
//通过mock js 获取知识推荐的数据
export const reqGetRecommendedKnowledge = () => mockRequests.get('/recommendedKnowledge')

//通过mock js 获取产品第一分页的数据
export const reqGetProductList1 = () => mockRequests.get('/productList1')
//通过mock js 获取产品第二分页的数据
export const reqGetProductList2 = () => mockRequests.get('/productList2')
//通过mock js 获取产品第三分页的数据
export const reqGetProductList3 = () => mockRequests.get('/productList3')
//通过mock js 获取产品第四分页的数据
export const reqGetProductList4 = () => mockRequests.get('/productList4')

//发送请求获取token
export const reqGetToken = () => requests({ url: "/manage/login", method: "POST", data: { "mobile": "web-zuofei", "password": "web-zuofei" } })
//将联系我们页面的用户数据发送到服务器
export const reqSendUserMsg = (params, headers) => requests({ url: "/manage/clue/create", method: "POST", data: params, headers: headers })

